<template>
  <div class="contactus_page"
    :style="{ width: showNavBar ? '100vw' : '100%', padding: showNavBar ? 'calc(20 * 100vw / 1920)' : 0 }">
    <div class="contactus" :style="{ margin: showNavBar ? 'calc(20 * 100vw / 1920) auto' : 0 }">
      <p class="directory" v-if="showNavBar">
        <span @click="homeClick" class="directory_home">Home </span> > Contact
        Us
      </p>
      <div class="contactus_title">Contact Us</div>
      <div class="contactus_main">
        <div class="list">
          <div class="list_li" v-for="(item, index) in customerServiceHotlink" :key="index">
            <img alt="图片" :src="$baseUrl + item.image"   />
            <div class="name">{{ item.name }}</div>
            <div class="email">{{ item.email }}</div>
            <div class="email">{{ item.domain }}</div>
            <div class="teltext flex-row">
              <div class="iconfont icon-tel"></div>
              /
              <div class="iconfont icon-wechat"></div>
              /
              <div class="iconfont icon-whatsapp"></div>
              :
            </div>
            <div class="tel">{{ item.contact }}</div>
          </div>
        </div>
        <div class="contact_info_img">
          <!-- <maps
            v-if="businessInfo.longitude && businessInfo.latitude"
            :longitude="businessInfo.longitude"
            :latitude="businessInfo.latitude"
          ></maps> -->
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import maps from "@/components/maps/map";
import { contactUs, businessIntroduction } from "../../api/business";
export default {
  name: "ContactUs",
  async asyncData() {
    const [contactRes, businessRes] = await Promise.all([
      contactUs().catch(() => ({ code: -1 })),
      businessIntroduction().catch(() => ({ code: -1 }))
    ])
    return {
      customerServiceHotlink: contactRes.code === 200 ? contactRes.data : [],
      businessInfo: businessRes.code === 200 ? businessRes.data : {}
    }
  },
  data() {
    return {
      customerServiceHotlink: [],
      businessInfo: {},
    };
  },
  components: {
    maps,
  },
  props: {
    showNavBar: {
      type: Boolean,
      default: () => true,
    }
  },
  computed: {},
  watch: {},
  methods: {
    homeClick() {
      this.$router.push({
        path: "/",
        query: {
          bool: true,
          noBusiness: true,
        },
      });
    },
    contactUs() {
      contactUs(sessionStorage.getItem("businessId")).then((res) => {
        // console.log(res);
        if (res.code == 200) {
          this.customerServiceHotlink = res.data;
        }
      });
    },
    businessIntroductionApi() {
      businessIntroduction(sessionStorage.getItem("businessId")).then((res) => {
        if (res.code == 200) {
          this.businessInfo = res.data;
        } else if (res.code == 401) {
          this.$message({
            message: res.code,
            type: "error",
          });
          //未登录
          this.$router.push({
            path: "/login",
            query: {
              box8: false,
              phoneHomeImg: false,
              bool: false,
            },
          });
          return;
        } else {
          // this.$message({ message: res.msg, type: "error" });
        }
      });
    },
  },
  mounted() {
    this.contactUs();
    this.businessIntroductionApi();
  },
};
</script>

<style scoped>
.contactus_page {
  width: 100vw;
  background-color: #f1f1f1;
  padding: calc(20 * 100vw / 1920);
}

.contactus {
  /* width: calc(1200 * 100vw / 1920); */
  width: 100%;
  min-height: 70vh;
  margin: calc(20 * 100vw / 1920) auto;
  background-color: #fff;
}

.directory {
  background-color: #f1f1f1;
  margin: 0;
  padding-bottom: 1.2vw;
  font-size: 0.93vw;
  font-family: Roboto;
  font-weight: 400;
  color: #999999;
}

.contactus_main {
  background-color: #fff;
  padding-bottom: calc(20 * 100vw / 1920);
  border-top: 1px solid #ddd;
}

.contactus_title {
  margin-left: calc(20 * 100vw / 1920);
  width: calc(140 * 100vw / 1920);
  height: calc(75 * 100vw / 1920);
  white-space: nowrap;
  line-height: calc(75 * 100vw / 1920);
  border-bottom: 5px solid rgba(19, 175, 135, 1);
  font-weight: bolder;
  font-size: 1.28vw;
}

.list {
  display: flex;
  font-size: calc(22 * 100vw / 1920);
  padding-top: calc(30 * 100vw / 1920);
  flex-wrap: wrap;
  justify-content: space-around;
}

.list_li {
  width: 33.33%;
  word-wrap: break-word;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  margin-bottom: calc(30 * 100vw / 1920);
}

.list_li>img {
  max-width: 40%;
  max-height: 40%;
  margin-bottom: calc(20 * 100vw / 1920);
}

.list_li>div {
  text-align: center;
  margin-bottom: calc(10 * 100vw / 1920);
}

.list_li .name {
  font-weight: 600;
}

.list_li .teltext {
  align-items: center;
}

.list_li .teltext>div {
  font-size: calc(22 * 100vw / 1920);
  margin: 0 calc(10 * 100vw / 1920);
  color: rgb(95, 94, 94);
}

.contact_info_img {
  height: calc(620 * 100vw / 1920);
  border-top: 1px solid #ddd;
  margin: 0 calc(20 * 100vw / 1920);
  margin-top: calc(20 * 100vw / 1920);
}
</style>
<style scoped>
@media screen and (max-width: 1080px) {
  .contactus_page {
    padding: 0;
  }

  .contactus {
    width: 100%;
    min-height: 70vh;
    margin: calc(20 * 100vw / 1080) auto;
    background-color: #fff;
    padding-bottom: calc(80 * 100vw / 1080);
    margin-bottom: 0;
  }

  .directory {
    display: none;
  }

  .contactus_title {
    margin-left: calc(40 * 100vw / 1080);
    width: calc(280 * 100vw / 1080);
    height: calc(145 * 100vw / 1080);
    white-space: nowrap;
    line-height: calc(145 * 100vw / 1080);
    border-bottom: calc(6 * 100vw / 1080) solid rgba(19, 175, 135, 1);
    font-weight: bolder;
    font-size: calc(48 * 100vw / 1080);
  }

  .list {
    font-size: calc(30 * 100vw / 1080);
    padding-top: calc(30 * 100vw / 1080);
  }

  .list_li {
    width: 50%;
    margin-bottom: calc(30 * 100vw / 1080);
  }

  .list_li .teltext>div {
    font-size: calc(30 * 100vw / 1080);
    margin: 0 calc(10 * 100vw / 1080);
    color: rgb(95, 94, 94);
  }

  .list_li>img {
    max-width: 40%;
    max-height: 40%;
    margin-bottom: calc(20 * 100vw / 1080);
  }

  .list_li>div {
    text-align: center;
    margin-bottom: calc(10 * 100vw / 1080);
  }

  .contact_info_img {
    height: calc(640 * 100vw / 1080);
    border-top: 1px solid #ddd;
    margin: 0 calc(20 * 100vw / 1080);
    margin-top: calc(10 * 100vw / 1080);
  }
}
</style>
